// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.75 3.5V12.5M8.5 3.5V12.5M2.75 8H8.5',
  'M10.75 6.75V9.25C10.75 9.8 11.2 10.25 11.75 10.25H14M14 6.75V12.5',
];
